module.exports = __webpack_public_path__ + "img/wx.5b222660.png";